

























































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";

import Detail from "./detail.vue";

import AiPlayerLog from "./detail_ai_player_log.vue";
@Component({
  components: {
    Detail,
    AiPlayerLog
  }
})
export default class extends Mixins(MyList) {
  @Prop() userId!: number;
  @Prop() type!: string;

  aiPlayerLogModalVisible: boolean = false;

  dispatchType: string = "users/player";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "球友名称", dataIndex: "player_nickname" },
    { title: "手机号", dataIndex: "player_mobile" },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "最后打球时间", dataIndex: "latest_play_time" },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  showAiPlayerLogModal(id: number) {
    this.editId = id;
    this.aiPlayerLogModalVisible = true;
  }

  hideAiPlayerLogModal() {
    this.aiPlayerLogModalVisible = false;
  }

  mounted() {
    if (this.type == "ai") {
      this.dispatchType = "users/aiPlayer";

      this.columns = [
        { title: "编号", dataIndex: "id" },
        { title: "球友名称", dataIndex: "player_nickname" },
        { title: "手机号", dataIndex: "player_mobile" },
        { title: "添加时间", dataIndex: "created_time" },
        { title: "最后打球时间", dataIndex: "latest_play_time" },
        { title: "状态", scopedSlots: { customRender: "cron_type_text" } },
        { title: "权重", dataIndex: "weight" },
        { title: "是否升级为球友", scopedSlots: { customRender: "is_upgrade" } },
        { title: "操作", scopedSlots: { customRender: "action" } }
      ];
    }
    this.loadData(
      {
        user_id: this.userId
      },
      false
    );
  }
}
